import Modal from './modules/modal.js'; //quite
//import mobileMenu from './modules/mobile-menu.js'; //quite

//import * as Swiper from './extern/swiper.js'; //quite
//import * as Fancybox from './extern/jquery.fancybox.js'; //quite

//Touch sniffer
if ('ontouchstart' in document.documentElement) {
	document.querySelector('html').classList.add('is-touch');
}

// Init functions on pageload
function init() {
	//mobileMenu();
	new Modal();
}

jQuery(document).ready(function ($) {
	init();
});
